import { createContext } from "react";

export const GalaxyContext = createContext({})
